import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/authSlice';
import uiReducer from './features/uiSlice';
import alertReducer from './features/alertSlice';
import reviewReducer from './features/reviewSlice';
import claimProjectReportsReducer from './features/claimProjectReportsSlice';
import companiesReducer from './features/companiesSlice';
import toastReducer from './features/toastSlice';
import navbarBreadcrumbReducer from './features/navbarBreadcrumbSlice';
import unsavedChangesReducer from './features/unsavedChangesSlice';
import errorReportReducer from './features/errorReportSlice';
import errorReportMiddleware from './features/errorReportMiddleware';
export default configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    alerts: alertReducer,
    review: reviewReducer,
    claimProjectReports: claimProjectReportsReducer,
    companies: companiesReducer,
    toast: toastReducer,
    navbarBreadcrumb: navbarBreadcrumbReducer,
    unsavedChanges: unsavedChangesReducer,
    errorReport: errorReportReducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: ['errorReport/setPendingErrorReport'],
      ignoredPaths: ['errorReport.screenshotFile']
    }
  }).concat(errorReportMiddleware)
});